export default ($axios) => {
  return {
    postContactUs: async (data) => {
      return await $axios.post('https://7vn5bzxbbi.execute-api.us-west-2.amazonaws.com/prod/email', data)
    },
  }
}